var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locale-switcher"},[_c('button',{staticClass:"button button--min button--grey",on:{"click":_vm.switchLocale}},[_vm._v(" "+_vm._s(_vm.lang)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }